import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * CarpoolLayer — renders the pool of nearby carpool drivers on the map.
 * Each driver = a car icon at their origin, a REAL OSRM polyline through
 * the rider stop to their destination, and a mini-tooltip. Booked drivers
 * dim + get a "matched" ring.
 */
import { Marker, Polyline, Tooltip } from "react-leaflet";
import L from "leaflet";
function carIcon(booked) {
    const stroke = booked ? "#8e8e95" : "#000d10";
    const fill = booked ? "#c9c9cf" : "#bc7155";
    return L.divIcon({
        className: `bb-carpool-marker ${booked ? "booked" : ""}`,
        html: `
      <div style="position:relative;width:26px;height:26px;display:grid;place-items:center;">
        <svg viewBox="0 0 24 24" width="22" height="22" xmlns="http://www.w3.org/2000/svg">
          <rect x="3" y="8" width="18" height="10" rx="3" fill="${fill}" stroke="${stroke}" stroke-width="1.5"/>
          <rect x="6" y="6" width="12" height="4" rx="1.5" fill="${fill}" stroke="${stroke}" stroke-width="1.2"/>
          <circle cx="7.5" cy="18" r="2" fill="${stroke}"/>
          <circle cx="16.5" cy="18" r="2" fill="${stroke}"/>
          <rect x="7" y="10" width="4" height="2" fill="#ffffff" opacity="0.9"/>
          <rect x="13" y="10" width="4" height="2" fill="#ffffff" opacity="0.9"/>
        </svg>
      </div>`,
        iconSize: [26, 26],
        iconAnchor: [13, 13],
    });
}
function riderIcon() {
    return L.divIcon({
        className: "bb-carpool-rider",
        html: `
      <div style="position:relative;width:20px;height:20px;display:grid;place-items:center;">
        <span style="position:absolute;inset:-4px;border-radius:50%;border:2px solid #bc7155;opacity:.5;animation:bb-ping 1.6s ease-in-out infinite"></span>
        <span style="width:12px;height:12px;border-radius:50%;background:#bc7155;border:2px solid #ffffff;"></span>
      </div>`,
        iconSize: [20, 20],
        iconAnchor: [10, 10],
    });
}
export function CarpoolLayer({ drivers, rider }) {
    return (_jsxs(_Fragment, { children: [rider ? (_jsx(Marker, { position: [rider.lat, rider.lng], icon: riderIcon(), children: _jsx(Tooltip, { direction: "top", offset: [0, -10], children: "rider stop" }) })) : null, drivers.map((d) => {
                const positions = d.polyline.map((p) => [p.lat, p.lng]);
                const color = d.booked ? "#8e8e95" : "#bc7155";
                const weight = d.booked ? 2 : 3;
                const opacity = d.booked ? 0.4 : 0.7;
                return (_jsxs("div", { style: { display: "contents" }, children: [positions.length >= 2 ? (_jsx(Polyline, { positions: positions, pathOptions: {
                                color,
                                weight,
                                opacity,
                                dashArray: d.polyline_source === "osrm" ? undefined : "6 6",
                            } })) : null, _jsx(Marker, { position: [d.origin.lat, d.origin.lng], icon: carIcon(d.booked), children: _jsx(Tooltip, { direction: "top", offset: [0, -12], children: `${d.name} · ★${d.trust_score.toFixed(1)} · ETA ${d.eta_min.toFixed(0)}min · ₹${d.fare_inr.toFixed(0)}` }) })] }, d.id));
            })] }));
}
